<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-mb-card tm-mb-curt-card">
    <v-row class="com-mb-card-contents-none-border" no-gutters>
      <v-sheet class="tm-mb-slider tm-mb-no-shadow">
        <v-carousel
          v-model="carouselIdx"
          height="115"
          hide-delimiter-background
          light
        >
          <v-carousel-item
            v-for="(obs, idx) in tmCoastList.curt.category"
            :key="obs.title"
          >
            <div class="tm-mb-slider-side">
              <v-row class="mx-0 px-3 tm-mb-slider-title">
                <div class="col-4 left">{{ prevTitle(idx) }}</div>
                <div class="col-4 pa-0 font-weight-bold">
                  {{ centerTitle(idx) }}
                </div>
                <div class="col-4 right">{{ nextTitle(idx) }}</div>
              </v-row>
            </div>

            <v-row no-gutters class="tm-mb-slider-contents" align="center">
              <v-sheet
                outlined
                v-for="item in obs.master"
                :key="item.label"
                class="tm-mb-slider-side-sub-item"
              >
                <div class="tm-mb-alert-color" :alert-color="item.ovflg">
                  <div class="tm-mb-slider-side-content tm-mb-slider-side-sub-item__name">{{ item.label }}</div>
                </div>
                <v-divider></v-divider>
                <div class="tm-mb-slider-side-content tm-mb-slider-side-sub-item__data">
                  {{ item.value }}&nbsp;
                  <span v-html="item.unit"></span>
                </div>
              </v-sheet>
            </v-row>
          </v-carousel-item>
        </v-carousel>
      </v-sheet>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]海岸 最新観測値カード
 * TmCoastCurt.vue
 * @author ILUKE
 */

export default {
  name: "tm-coast-curt",
  data() {
    return {};
  },
  props: {
    carousel: { default: 0, type: Number },
  },
  created: function() {
    this.$store.commit("Telemeter/setLatestObsIdx", this.carousel);
  },
  computed: {
    carouselIdx: {
      get() {
        return this.$store.state.Telemeter.latestObsIdx;
      },
      set(val) {
        this.$store.commit("Telemeter/setLatestObsIdx", val);
      },
    },
    /**
     * 海岸情報 取得
     */
    tmCoastList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    prevTitle: function() {
      return function(idx) {
        if (idx === 0) {
          idx = this.$store.state.Telemeter.selectedTm.curt.category.length - 1;
        } else {
          idx = idx - 1;
        }
        var prevTitle = this.$store.state.Telemeter.selectedTm.curt.category[
          idx
        ].title;
        return prevTitle;
      };
    },
    centerTitle: function() {
      return function(idx) {
        var centerTitle;
        if (idx === 0) {
          centerTitle = "";
        } else {
          centerTitle = this.$store.state.Telemeter.selectedTm.curt.category[
            idx
          ].title;
        }
        return centerTitle;
      };
    },
    nextTitle: function() {
      return function(idx) {
        if (
          idx ===
          this.$store.state.Telemeter.selectedTm.curt.category.length - 1
        ) {
          idx = 0;
        } else {
          idx = idx + 1;
        }
        var nextTitle = this.$store.state.Telemeter.selectedTm.curt.category[
          idx
        ].title;
        return nextTitle;
      };
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
